<template>
	<div id="app">
		<!-- <router-view></router-view> -->
		 <Home/>
	</div>
</template>
<script setup>
	import Home from "./views/Home/index.vue"
</script>

<style lang="less" scoped></style>
